/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Rename_Success_ToastInputs */

const en_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Record renamed to "${i?.name}"`)
};

const fr_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement renomme en "${i?.name}"`)
};

const de_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Datensatz umbenannt in "${i?.name}"`)
};

const it_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Record rinominato in "${i?.name}"`)
};

const ru_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запись переименована в "${i?.name}"`)
};

const es_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registro renombrado a "${i?.name}"`)
};

const zh_cn2_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`记录已重命名为“${i?.name}”`)
};

const ja_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`レコード名が「${i?.name}」に変更されました`)
};

const hi_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड का नाम बदलकर "${i?.name}" कर दिया गया है।`)
};

const pt_pt2_explorer_info_rename_success_toast = /** @type {(inputs: Explorer_Info_Rename_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registro renomeado para "${i?.name}"`)
};

/**
* | output |
* | --- |
* | "Record renamed to \"{name}\"" |
*
* @param {Explorer_Info_Rename_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_success_toast = /** @type {((inputs: Explorer_Info_Rename_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_rename_success_toast(inputs)
	if (locale === "de") return de_explorer_info_rename_success_toast(inputs)
	if (locale === "it") return it_explorer_info_rename_success_toast(inputs)
	if (locale === "ru") return ru_explorer_info_rename_success_toast(inputs)
	if (locale === "es") return es_explorer_info_rename_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_rename_success_toast(inputs)
	if (locale === "ja") return ja_explorer_info_rename_success_toast(inputs)
	if (locale === "hi") return hi_explorer_info_rename_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_rename_success_toast(inputs)
	return en_explorer_info_rename_success_toast(inputs)
});